export default __webpack_public_path__ + "static/meshery-issues-5edca9398a42a7ca68680bca5a05fec9.png";